import { render, staticRenderFns } from "./Newcomers.vue?vue&type=template&id=2c243416"
import script from "./Newcomers.vue?vue&type=script&lang=js"
export * from "./Newcomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports